// extracted by mini-css-extract-plugin
export var searchHeader = "_2p-0";
export var searchHeaderDark = "_2p-1";